export const mediaSm = '@media (max-width: 800px)';
export const mediaMd = '@media (max-width: 1000px)';
